<template>
  <div class="text-center">
    <h2 id="iphone" class="mb-3">スマホのホーム画面に<br>MSC会員サイトのアイコンを追加<br>（機種選択）</h2>
    
    <div class="text-center mt-5 pt-5">
      <router-link class="btn d-inline-block" style="width: 250px;" to="/lp/homeicon-iphone">IPhoneの方はこちらから</router-link>
    </div>
    <div class="text-center mt-5 pt-5">
      <router-link class="btn d-inline-block" style="width: 250px;" to="/lp/homeicon-android">Androidの方はこちらから</router-link>
    </div>

  </div>
  <div class="text-center mt-5 pt-5">
    <router-link class="btn" to="/">会員サイトトップへ</router-link>
  </div>
</template>


<style scoped>
</style>

<script>
</script>